import { Controller } from "@hotwired/stimulus"
import { Wallet } from '@cardano-foundation/cardano-connect-with-wallet-core'

export default class extends Controller {
  static targets = ["button"]
  static values = {
    network: { type: String, default: "mainnet" }
  }

  initialize() {
    this.installedWallets = Wallet.getInstalledWalletExtensions();
  }

  buttonTargetConnected(button) {
    if(!this.installedWallets.includes(button.value)) {
      button.disabled = true;
      button.classList.add("greyscale", "opacity-50");
      button.querySelector(".not-installed").classList.remove("d-none");
    }
  }

  async selectWallet(event) {
    this.messageSigned = false;
    this.authenticated = false;

    let button = event.currentTarget;
    let spinner = button.querySelector(".spinner");
    let statusIcon = button.querySelector(".status-icon");

    statusIcon.classList.add("d-none");
    spinner.classList.remove("d-none");
    await this.connectToWallet(button.value);
    spinner.classList.add("d-none");

    if (this.authenticated) {
      statusIcon.classList.add("fa-regular", "fa-circle-check", "text-success");
    } else {
      statusIcon.classList.add("fa-solid", "fa-circle-exclamation", "text-alert");
    }

    statusIcon.classList.remove("d-none");
  }

  async connectToWallet(wallet) {
    try {
      await Wallet.connectToWallet(wallet, this.networkValue, 2, 500);
      console.log('Connected to ', wallet);
    } catch (error) {
      console.error('Error connecting to wallet', error);
      return;
    }

    try {
      const stakeAddresses = await Wallet.getRewardAddresses();
      this.stakeAddress = stakeAddresses[0];
    } catch (error) {
      console.error('Error fetching stake address', error);
      return;
    }

    try {
      await this.signMessage();
    } catch (error) {
      console.error('Error signing message', error);
      return;
    }

    if (this.messageSigned) {
      await this.verifyAuth().then((response) => {
        this.authenticated = true;
        console.log("Authenticated!", response);
        const redirect_url = response.url.toString()
        Turbo.visit(new URL(redirect_url, document.baseURI));
      }).catch((error) => {
        console.error("Auth verification failed", error);
      });
    }
  }

  async signMessage() {
    try {
      this.nonce = await this.requestNonce();
    } catch (error) {
      console.error("Error fetching nonce", error);
      return;
    }

    try {
      return Wallet.signMessage(
        this.nonce,
        (signature, key) => {
          this.dataSignature = { signature: signature, key: key };
          this.messageSigned = true;
        },
        (error) => {
          console.error("Signing Error:", error);
          return;
        }
      )
    } catch (error) {
      console.error("Unexpected Error:", error);
    }
  }

  async requestNonce() {
    return fetch("/wallet_auth/nonce", { method: "POST" })
      .then(response => response.json())
      .then(data => {
        return data.nonce;
      });
  }

  async verifyAuth() {
    return fetch("/wallet_auth/verify", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ stakeAddress: this.stakeAddress, signature: this.dataSignature.signature, key: this.dataSignature.key, nonce: this.nonce }),
    }).then(response => {
      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }
      return response.json();
    });
  }

  disconnectWallet() {
    Wallet.disconnect().then(() => {
      console.log('Disconnected wallet');
      this.removeLastConnectedWallet();
    }).catch((error) => {
      console.error('Error disconnecting wallet', error);
    });
  }
}
